import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '@utils/formater';
import STATUS_COLORS from '@pages/lending/constants/StatusColors';

interface RowsProps {
  row: any;
  showInvoice: (id: string) => void;
  showDetail: (id: string) => void;
  paylending: (id: string) => void;
}

const TableRowComponent = ({
  row,
  showInvoice,
  showDetail,
  paylending,
}: RowsProps) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <TableRow
      key={row.id}
      className="!rounded-xl !border border-slate-300 mxx-10"
    >
      <TableCell className="!text-center border rounded-tl-xl rounded-bl-xl border-r-0">
        {row.providerName}
      </TableCell>
      <TableCell className="!text-center border-t">
        <div
          className={`${
            STATUS_COLORS[
              (parseInt(row.id, 10) - 1) as keyof typeof STATUS_COLORS
            ]
          } rounded px-2 py-1 text-white`}
        >
          {row.status}
        </div>
      </TableCell>
      <TableCell className="!text-center border-t">{row.advance}</TableCell>
      <TableCell className="!text-center border-t">{row.funds}</TableCell>
      <TableCell className="!text-center border-t">
        {DateTime.fromISO(row.requestDate).toLocaleString(DateTime.DATE_MED, {
          locale: i18n.language,
        })}
      </TableCell>
      <TableCell className="!text-center border-t">
        {formatCurrency(row.amount)}
      </TableCell>
      <TableCell className="!text-center border-t">
        {formatCurrency(row.desAmount)}
      </TableCell>
      <TableCell className="!text-center border-t">
        {DateTime.fromISO(row.settlementDate).toLocaleString(
          DateTime.DATE_MED,
          {
            locale: i18n.language,
          }
        )}
      </TableCell>
      <TableCell className="!text-center border rounded-tr-xl rounded-br-xl border-l-0">
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="lending-actions-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={() => showInvoice(row.id)}>
            <ListItemIcon>
              <TaskOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Pagar
          </MenuItem>
          <MenuItem onClick={() => showDetail(row.id)}>
            <ListItemIcon>
              <FormatListBulletedOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Ver detalle
          </MenuItem>
          <MenuItem onClick={() => paylending(row.id)}>
            <ListItemIcon>
              <FileOpenOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Factura/PO
          </MenuItem>
        </Menu>
      </TableCell>
    </TableRow>
  );
};

export default TableRowComponent;
